<template>
    <div class="betBuilderBetBuilderTab-container">
        <Spinner v-if="!isFirstTimeAllLoaded" />
        <div
            v-show="isFirstTimeAllLoaded && visibleCombinations.length > 0"
            class="betBuilderBetBuilderTab notranslate"
        >
            <BetBuilderCombinationWorker
                v-for="c in combinations"
                v-bind:key="c.combinationKey"
                v-bind:combination="c"
                v-bind:isEnabled="isEnabledWs"
            />
            <div class="card_header">
                <SboIcon
                    name="system:fire"
                    class="hotIcon"
                    size="16"
                />
                <span class="title">{{ sectionTitle }}</span>
            </div>
            <div class="betBuilderBetBuilderTab-body betBuilderBetBuilderTab">
                <Carousel
                    v-bind:itemsToShow="1.1"
                    v-bind:itemsToScroll="1"
                    v-bind:mouseDrag="true"
                    v-bind:wrapAround="false"
                    name="slide-fade"
                    class="betBuilderBetBuilderTab-content"
                >
                    <Slide
                        v-for="(combination, index) in visibleCombinations"
                        v-bind:key="combination.combinationKey"
                    >
                        <BetBuilderCombinationByMatch
                            v-bind:combination="combination"
                            v-bind:order="index + 1"
                            v-bind:betPage="BetPageType.BetBuilderRecommendation_BetBuilderTab"
                            addToSlipGa="MatchCard_Btn_PreBuilt_AddToSlip"
                        />
                    </Slide>
                </Carousel>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { storeToRefs } from 'pinia';
    import { computed } from 'vue';
    import { Carousel, Slide } from 'vue3-carousel';
    import SboIcon from '@/components/common/SboIcon.vue';
    import Spinner from '@/components/common/Spinner.vue';
    import BetBuilderCombinationByMatch from '@/components/recommendations/BetBuilderCombinationByMatch.vue';
    import BetBuilderCombinationWorker from '@/components/recommendations/BetBuilderCombinationWorker.vue';
    import { BetBuilderCombinationsContext } from '@/components/recommendations/BetBuilderCombinationsContext';
    import { BetPageType } from '@/interface/enum';
    import { i18n } from '@/libraries/i18n';
    import { useBetBuilderRecommendationsByMatch } from '@/libraries/recommendation/useBetBuilderRecommendationsByMatch';
    import { useFeatureToggleStore } from '@/stores/featureToggleStore';
    import { useRootStore } from '@/stores/rootStore';

    interface Props {
        eventId: number;
        isLive: boolean;
    }

    const props = defineProps<Props>();

    const sectionTitle = computed(() => i18n.t('popular_combination_section_title'));

    const { isAsi } = storeToRefs(useRootStore());
    const {
        isPrebuiltInMatchDetailAndBetBuilderTabEnabled,
        matchDetailPrebuiltDisplayRule,
    } = storeToRefs(useFeatureToggleStore());

    const { betBuilderRecommendations, isLoaded: isBetBuilderRecommendationsLoaded } = useBetBuilderRecommendationsByMatch(
        props.eventId,
        props.isLive,
        matchDetailPrebuiltDisplayRule,
        isPrebuiltInMatchDetailAndBetBuilderTabEnabled,
    );

    const {
        combinations,
        visibleCombinations,
        isFirstTimeAllLoaded: _isFirstTimeAllLoaded,
    } = BetBuilderCombinationsContext.provide(betBuilderRecommendations);

    const isFirstTimeAllLoaded = computed(() => {
        if (isBetBuilderRecommendationsLoaded.value && combinations.value.length === 0) {
            return true;
        }
        return _isFirstTimeAllLoaded.value && isBetBuilderRecommendationsLoaded.value;
    });

    const isEnabledWs = computed(() => isAsi.value);
</script>

<style lang="scss" scoped>
@import "vue3-carousel/dist/carousel.css";
@import "@/scss/components/betBuilderBetBuilderTab";
@import "@/scss/components/quickCombination";
@import "@/scss/components/quickCombinationTicket";
</style>
